import { makeAutoObservable } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'

export class ReviewsStore {
  isLoading = false

  constructor(readonly entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  init() {}

  get isEmpty() {
    return true
  }

  dispose() {}
}
